/** Labels describe the submitted lookup, not text still being typed in the field. */
export function orderLookupMatch(
  query: string,
  order: { id: number; client_phone?: string | null }
): 'id' | 'phone' | 'phone-fragment' | null {
  query = query.trim();
  if (!query) return null;
  const explicitId = /^[#№]\s*\d+$/.test(query);
  if (!explicitId && !/^\+?[\d\s().-]+$/.test(query)) return null;
  const digits = query.replace(/\D/g, '');
  if (!digits) return null;
  const fullPhone = /^(?:0\d{9}|380\d{9})$/.test(digits);
  if ((explicitId || (!fullPhone && /^\d+$/.test(query))) && Number(digits) === order.id) {
    return 'id';
  }
  if (explicitId) return null;
  const normalize = (value: string) => /^380\d{9}$/.test(value) ? value.slice(2) : value;
  const phone = String(order.client_phone ?? '').replace(/\D/g, '');
  const term = normalize(digits);
  if (normalize(phone) === term) return 'phone';
  return phone.includes(term) ? 'phone-fragment' : null;
}
